import { render, staticRenderFns } from "./Busse.vue?vue&type=template&id=42b0a2e2&scoped=true&"
import script from "./Busse.vue?vue&type=script&lang=js&"
export * from "./Busse.vue?vue&type=script&lang=js&"
import style0 from "./Busse.vue?vue&type=style&index=0&id=42b0a2e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b0a2e2",
  null
  
)

export default component.exports